<template>
  <v-container fill-height fluid pl-0 pr-0>
    <v-row align="center" class="justify-center">
      <v-btn
            align='center'
            text
            color="primary" @click="print">Print
      </v-btn>
    </v-row>
    <v-row id="printMe">
      <v-card
        class="mx-auto mt-0"
        width="1000"
      >
        <v-card-title class="justify-center">
            <span class="title font-weight-light justify-center">{{medication[0]['resident']['fullName']}}</span>
        </v-card-title>
      </v-card>
    <v-col cols="12" lg="6" md="6">
      <v-card
        class="mx-auto mt-2 pb-0 mb-0"
        width="1000"
      >
        <v-card-text>
            <div class="text--primary">
              <p class="mb-8"><b>Medication:</b> {{medication[0]['resident']['medication']}}</p>
              <p class="mb-8"><b>Medication name:</b> {{medication[0]['name']}}</p>
              <p class="mb-8"><b>Directive: </b>{{medication[0]['directive']}}</p>
              <p class="mb-8"><b>Description:</b> {{medication[0]['description']}}</p>
              <p class="mb-8"><b>Receive Time:</b> {{medication[0]['receiveTime']}}</p>
              <p class="mb-8"><b> Quantity Order:</b> {{medication[0]['quantity']['order']}}</p>
              <p class="mb-8"><b> Quantity Receive:</b> {{medication[0]['quantity']['receive']}}</p>
              <p class="mb-8"><b>Schedule Time:</b> {{medication[0]['scheduleTime'] || 'Not set'}}</p>
            </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" lg="6" md="6">
        <v-card
        class="mx-auto mt-2 pb-0 mb-0"
        width="1000"
      >
        <v-card-text>
            <div class="text--primary">
                <p class="mb-8"><b> Type:</b> {{medication[0]['type']}}</p>
                <p class="mb-8"><b> Pharmacy:</b> {{medication[0]['pharmacy']}}</p>
                <p class="mb-8"><b> Start Date:</b> {{medication[0]['startDate']}}</p>
                <p class="mb-8"><b> End Date:</b> {{medication[0]['endDate']}}</p>
                <p class="mb-8"><b> Witness:</b> {{medication[0]['witness']}}</p>
                <p class="mb-8"><b> Date Of Birth:</b> {{medication[0]['resident']['dateOfBirth']}}</p>
                <p class="mb-8"><b> Funding:</b> {{medication[0]['resident']['funding']}}</p>
            </div>
        </v-card-text>
      </v-card>
    </v-col>
    
    <!-- Schedule Information Section -->
    <v-col cols="12" lg="12" md="12">
        <v-card
        class="mx-auto mt-2 pb-0 mb-0"
        width="1000"
      >
        <v-card-title>
          <v-icon left color="primary">schedule</v-icon>
          Medication Schedule
        </v-card-title>
        <v-card-text>
            <div class="text--primary">
                <p class="mb-4"><b>Scheduled Days:</b></p>
                <v-row>
                  <v-col cols="6" sm="4" md="3" v-for="day in daysOfWeek" :key="day.value">
                    <v-chip
                      :color="medication[0]['schedule'] && medication[0]['schedule'][day.value] ? 'success' : 'grey'"
                      text-color="white"
                      small
                      class="ma-1"
                    >
                      <v-icon left small v-if="medication[0]['schedule'] && medication[0]['schedule'][day.value]">check</v-icon>
                      {{ day.label }}
                    </v-chip>
                  </v-col>
                </v-row>
                <p class="mb-8 mt-4" v-if="!medication[0]['schedule'] || !hasScheduledDays">
                  <em>No specific days scheduled</em>
                </p>
            </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- File Attachments Section -->
    <v-col cols="12" lg="12" md="12">
        <v-card
        class="mx-auto mt-2 pb-0 mb-0"
        width="1000"
      >
        <v-card-title>
          <v-icon left color="primary">attach_file</v-icon>
          Required Documents
        </v-card-title>
        <v-card-text>
            <div class="text--primary">
                <v-row>
                  <v-col cols="12" md="4" v-for="fileType in fileTypes" :key="fileType.value">
                    <v-card outlined class="pa-3">
                      <v-card-title class="pa-0 pb-2">
                        <v-icon left :color="getFileIconColor(fileType.value)">{{ getFileIcon(fileType.value) }}</v-icon>
                        {{ fileType.label }}
                      </v-card-title>
                      <v-card-text class="pa-0">
                        <div v-if="hasFile(fileType.value)">
                          <p class="mb-2">
                            <v-icon small left>{{ getFileInfo(fileType.value).icon }}</v-icon>
                            {{ getFileInfo(fileType.value).fileName }}
                          </p>
                          <v-btn
                            small
                            color="primary"
                            @click="downloadFile(fileType.value)"
                            class="mr-2"
                          >
                            <v-icon left small>download</v-icon>
                            Download
                          </v-btn>
                          <v-btn
                            small
                            color="error"
                            @click="deleteFile(fileType.value)"
                          >
                            <v-icon left small>delete</v-icon>
                            Delete
                          </v-btn>
                        </div>
                        <div v-else>
                          <p class="text--secondary mb-2">No file uploaded</p>
                          <v-file-input
                            v-model="fileInputs[fileType.value]"
                            :label="`Upload ${fileType.label}`"
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt"
                            prepend-icon="mdi-file-upload"
                            show-size
                            @change="handleFileUpload(fileType.value, $event)"
                            hide-details
                          ></v-file-input>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
            </div>
        </v-card-text>
      </v-card>
    </v-col>
    <img height="50" width="50" src="../../assets/logo.png" class="mx-4">
    </v-row>
  </v-container>
</template>

<script>
import medicationApi from '../../services/api/MedicationApi';
import residentApi from '../../services/api/ResidentApi';
import fileUploadApi from '../../services/api/FileUploadApi';
export default {
    name: 'medicationDetail',
    data() {
        return {
            medication: '',
            totalMedication:'',
            medicationId:'',
            residentId:'',
            fileInputs: {
                authorization: null,
                prn: null,
                riskAssessment: null
            },
            fileTypes: [
                { value: 'authorization', label: 'Authorization Document' },
                { value: 'prn', label: 'PRN Document' },
                { value: 'riskAssessment', label: 'Risk Assessment Document' }
            ],
            daysOfWeek: [
                { value: 'monday', label: 'Monday' },
                { value: 'tuesday', label: 'Tuesday' },
                { value: 'wednesday', label: 'Wednesday' },
                { value: 'thursday', label: 'Thursday' },
                { value: 'friday', label: 'Friday' },
                { value: 'saturday', label: 'Saturday' },
                { value: 'sunday', label: 'Sunday' }
            ]
        }
    },
    computed: {
        hasScheduledDays() {
            if (!this.medication[0] || !this.medication[0]['schedule']) return false
            const schedule = this.medication[0]['schedule']
            return Object.values(schedule).some(day => day === true)
        }
    },
    created() {
        this.medicationId = this.$route.params.medicationId;
        this.residentId = this.$route.params.residentId;
        console.log(this.medicationId)
        console.log(this.residentId);
        this.get_registered_medication();
    },
    methods: {
        get_registered_medication () {
          this.loading = true
          return new Promise((resolve, reject) => {
              medicationApi.getRegisteredMedication({page: '', count:'', id:this.residentId, q:'', orderBy:'', order: ''})
                .then(medications => {
                    this.medication = medications.result.filter(item => item.id === this.medicationId)
                    this.totalMedication = this.medication.length
                })
                .catch(error => {
                    return reject(error)
                })
          })
        },
        load_more(residentId){
          this.residentId = residentId;
          return new Promise((resolve, reject) => {
              residentApi.getResident({residentId})
                .then(resident => {
                    this.resident = resident.result
                })
                .catch(error => {
                    return reject(error)
                })
          })
        },
        print () {
          this.$htmlToPaper('printMe');
        },
        hasFile(fileType) {
            return this.medication[0] && this.medication[0][`${fileType}File`];
        },
        getFileInfo(fileType) {
            const filePath = this.medication[0][`${fileType}File`];
            const fileName = this.medication[0][`${fileType}FileName`];
            const fileInfo = fileUploadApi.getFileInfo(filePath);
            // Use stored filename if available
            if (fileName) {
                fileInfo.fileName = fileName;
            }
            return fileInfo;
        },
        getFileIcon(fileType) {
            if (this.hasFile(fileType)) {
                return this.getFileInfo(fileType).icon;
            }
            return 'mdi-file-upload';
        },
        getFileIconColor(fileType) {
            if (this.hasFile(fileType)) {
                return 'success';
            }
            return 'grey';
        },
        async downloadFile(fileType) {
            try {
                await fileUploadApi.downloadMedicationFile(this.medicationId, fileType);
            } catch (error) {
                console.error('Error downloading file:', error);
                alert('Error downloading file: ' + error.message);
            }
        },
        async deleteFile(fileType) {
            if (confirm('Are you sure you want to delete this file?')) {
                try {
                    await fileUploadApi.deleteMedicationFile(this.medicationId, fileType);
                    // Refresh medication data to update UI
                    await this.get_registered_medication();
                    alert('File deleted successfully');
                } catch (error) {
                    console.error('Error deleting file:', error);
                    alert('Error deleting file: ' + error.message);
                }
            }
        },
        async handleFileUpload(fileType, file) {
            if (!file) return;
            
            try {
                await fileUploadApi.uploadMedicationFile(this.medicationId, fileType, file);
                // Refresh medication data to update UI
                await this.get_registered_medication();
                alert('File uploaded successfully');
                // Clear the file input
                this.fileInputs[fileType] = null;
            } catch (error) {
                console.error('Error uploading file:', error);
                alert('Error uploading file: ' + error.message);
            }
        }
    }
}
</script>

<style scoped lang="scss">
  #block {
    float: left;
  }
</style>